import { gql } from '@apollo/client';

const EXPORT_TRANSLATE_IMPROVEMENTS_QUERY = gql`
  query exportTranslateImprovements(
    $end: DateTime = null
    $ianaTimeZone: String!
    $language: ECountry = null
    $projectId: String!
    $start: DateTime = null
    $status: ETranslateImprovementsStatus = null
  ) {
    translateImprovement {
      exportTranslateImprovements: export(
        end: $end
        ianaTimeZone: $ianaTimeZone
        language: $language
        projectId: $projectId
        start: $start
        status: $status
      ) {
        presignedUrl
      }
    }
  }
`;

export { EXPORT_TRANSLATE_IMPROVEMENTS_QUERY };
